/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------

==========================================================================================*/


export default [
  {
    url: '/users',
    slug: 'users',
    icon: 'users-icon',
    featherIcon: false,
    i18n: 'users.list.title',
    permission: 'users_menu'
  },
  {
    url: '/tasks',
    slug: 'taskList',
    icon: 'square-check-icon',
    featherIcon: false,
    i18n: 'tasks.list.title',
    permission: 'tasks_menu'
  },
  {
    url: '/tickets',
    slug: 'tickets',
    icon: 'headset-icon',
    featherIcon: false,
    i18n: 'tickets.list.title',
    permission: 'ticket_menu'
  }
]
